import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

@Component({
  selector: 'app-loan-eligibility-personal-info',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule,TranslocoDirective,TranslocoPipe, NgxMaskDirective],
  templateUrl: './loan-eligibility-personal-info.component.html',
  styleUrl: './loan-eligibility-personal-info.component.css',
  providers: [provideNgxMask()],
})
export class LoanEligibilityPersonalInfoComponent {
  @Input() form!: FormGroup;
  protected formGroup!: FormGroup;
  protected currentYear: number = new Date().getFullYear();

  ngOnInit() {
    this.formGroup = this.form.get('personalInfo') as FormGroup;
  }

  protected hasError(controlName: string): boolean {
    const control = this.formGroup.get(controlName) as FormControl;
    if (!control) return false;
    const result = control.invalid && control.touched;
    return result;
  }
}
